<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
      row
    >
    <v-flex xs12 md6> 
      
            <v-select
              :items="userList"
              label="Select User"
              item-text="name"
              item-value="id"
              v-model="payment.user_id"
              @change="onChangeUser"
            ></v-select>
      <!-- <v-text-field label="Search user by Phone" class="green-input" /> -->
      <v-layout row class="pb-0">
      <v-flex md12 class="px-0" v-if="payment.user_id">
        <material-card  color="green" :title="userDetail.name">
         <v-layout row>
          <v-flex sm6 class="px-4 font-weight-bold">
            Phone:
          </v-flex>
          <v-flex sm6 class="px-0 font-weight-reqular">
            {{ userDetail.mobile_number }}
          </v-flex>
         </v-layout>
         <v-layout row>
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Email:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ userDetail.email }}
          </v-flex>
         </v-layout>
         <v-layout row>
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Address:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ userDetail.address }}
          </v-flex>
         </v-layout>
         <v-layout row>
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Balance:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ userDetail.balance }}
          </v-flex>
         </v-layout>
        </material-card>
      </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md6> 
      <v-text-field label="Search item by Code" v-model="payment.code" class="green-input" @keyup="searchByCode" />
          
      <v-layout row class="pb-0">
      <v-flex md12 class="px-0" v-if="payment.code && itemForPayment">
        <material-card  color="green" :title="itemForPayment.type ?  itemForPayment.type : 'No Item found'">
         <v-layout row v-if="itemForPayment.name">
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Name:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ itemForPayment.name }}
          </v-flex>
         </v-layout>

         <v-layout row v-if="itemForPayment.course">
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Course Name:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ itemForPayment.course.name }}
          </v-flex>
         </v-layout>
         <v-layout row v-if="itemForPayment.subject">
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Subject Name:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ itemForPayment.subject.name }}
          </v-flex>
         </v-layout>
         <v-layout row v-if="itemForPayment.chapter">
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Chapter Name:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ itemForPayment.chapter.name }}
          </v-flex>
         </v-layout>
         <v-layout row v-if="itemForPayment.price">
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Price:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ itemForPayment.price }}
          </v-flex>
         </v-layout>
         <v-layout row>
          <v-flex sm6 class="px-4 pt-0 font-weight-bold">
            Payable amount:
          </v-flex>
          <v-flex sm6 class="px-0 pt-0 font-weight-reqular">
            {{ itemForPayment.payable_amount ? itemForPayment.payable_amount : 'Already bought' }}
          </v-flex>
         </v-layout>
         <v-layout row>
          <v-flex sm12 class="px-0 font-weight-reqular" v-if="itemForPayment.payable_amount">
            <v-btn left color="green" @click="addToList" small>Add to List</v-btn>
          </v-flex>
         </v-layout>
         
        </material-card>
      </v-flex>
      </v-layout>
    </v-flex>
    
    <!-- <v-layout row v-if="payment.user_id && payment.code">
      
    <v-flex xs12 sm3>
        <v-text-field label="Amount" v-model="payment.amount" class="green-input" type="number"/>
    </v-flex>
    <v-flex xs12 sm3>
        <v-text-field label="Discount" v-model="payment.discount" class="green-input" type="number"/>
    </v-flex>
    <v-flex xs12 sm6>
      <v-btn color="green" @click="onSubmitPayment">
        Submit
      </v-btn>
    </v-flex>
    </v-layout> -->


         
   <v-flex xs12 sm12 md12>

    <material-card color="green" title="Item list to purchase" text v-if="itemDetailList.length">
      <v-data-table  :headers="headers" :items="itemDetailList" >
        <template slot="headerCell" slot-scope="{ header }">
          <span class="subheading font-weight-light text--darken-3" v-text="header.text" />
        </template>
        <template slot="items" slot-scope="{ item }">
          <td> {{ item.name }}
            <small v-if="item.course"> (
              {{  item.course.name  }}
              {{ item.subject? ' | ' + item.subject.name : '' }}
              {{ item.chapter? ' | ' + item.chapter.name : '' }}
               ) </small>
          </td>
          <td>{{ item.type }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.payable_amount }}</td>
          <td>
            <v-btn color="red" small @click="removeItem(itemDetailList.indexOf(item))">Remove</v-btn>
          </td>
        </template>
      </v-data-table>
    </material-card>
    </v-flex>
    
      <v-flex
        xs12
        md12
        v-if="itemDetailList.length"
      >
        <v-dialog
          v-model="dialog"
          width="1000"
          hegiht="auto"
          persistent
        >
          <template v-slot:activator="{ on }">
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Payment
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
            <Form
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="onSubmitPayment"
              @closed="closeModal"
              />
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <!-- <v-layout row v-if="payment.user_id && payment.code">
    </v-layout> -->
 
            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div>{{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Form from '@/views/Form'
export default {
  components: {
    Form
  },
  computed: {
    ...mapState('payments', ['userList', 'payment', 'userDetail', 'itemForPayment', 'itemDetailList', 'itemList']),
  },
  mounted () {
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    headers: [
      {
        sortable: true,
        text: 'Item Name',
        value: 'name'
      },
      {
        sortable: false,
        text: 'Type',
        value: 'type'
      },
      {
        sortable: false,
        text: 'Code',
        value: 'code'
      },
      {
        sortable: false,
        text: 'Payable Amount (BDT)',
        value: 'code'
      },
      {
        sortable: false,
        text: 'Action',
        value: ''
      },
    ],
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'Create new',
        'subTitle': '',
        'width': 'md12',
        'submitText' : 'Submit'
      },
      valueObj: { },
      inputFields: [
        {
          label: 'Payment amount',
          type: 'number',
          isEnable: true,
          name: 'amount',
          formName: 'amount',
          nameRules: [
            v => !!v || 'Amount is required'
          ]
        },
        {
          label: 'Discount',
          type: 'number',
          isEnable: true,
          name: 'discount',
          formName: 'discount',
           nameRules: [
          ]
        },
        {
          label: 'Payment method',
          type: 'test',
          isEnable: true,
          name: 'payment_method',
          formName: 'payment_method',
          nameRules: [
            v => !!v || 'Payment method is required'
          ]
        },
       
      ],
      searchQuery: '',
      isTyping: false,
      some: {},
      paymentItems: [],
      list: []
    }
  },
  created () {
    this.getUserList()
  },
  watch : {
      payment:function(val) {
        this.searchByCode()
      }
  },
  methods: {
    ...mapActions("payments", ['getUserList', 'getUserDetails', 'searchByCode', 'purchaseList']),

    onChangeUser () {
      this.getUserDetails(this.payment.user_id)
      this.searchByCode()
    },
    addToList () {
      let isExist = false
      let item = {}
      let newArrayToRemove = []
      let newArrayDetailToRemove = []

      if (this.itemForPayment.type == 'Lecture') {
        this.$store.state.payments.itemList.forEach( (element, i) => {
          if (element.lecture_id == null && (element.course_id == this.itemForPayment.course_id || element.subject_id == this.itemForPayment.subject_id || element.chapter_id == this.itemForPayment.chapter_id) ){
            isExist = true
          }
          if (this.itemForPayment.id == element.lecture_id) {
            this.$store.state.payments.itemList.splice( i, 1 )
            this.$store.state.payments.itemDetailList.splice( i, 1 )
          }
        })
        item = {
          'course_id': this.itemForPayment.course_id,
          'subject_id': this.itemForPayment.subject_id,
          'chapter_id': this.itemForPayment.chapter_id,
          'lecture_id': this.itemForPayment.id,
        }
      } else if (this.itemForPayment.type == 'Chapter') {
        this.$store.state.payments.itemList.forEach( (element, i) => {
          
          if( (element.chapter_id == this.itemForPayment.id || (element.course_id == this.itemForPayment.course_id && element.chapter_id == null ) || ( element.subject_id == this.itemForPayment.subject_id && element.course_id == this.itemForPayment.course_id && element.chapter_id == null ) ) && element.lecture_id == null){
            isExist = true
          }
          if (this.itemForPayment.id == element.chapter_id && element.lecture_id != null) {
            
            newArrayToRemove.push(element)
            newArrayDetailToRemove.push(this.$store.state.payments.itemDetailList[i])
          }
        })
          item = {
            'course_id': this.itemForPayment.course_id,
            'subject_id': this.itemForPayment.subject_id,
            'chapter_id': this.itemForPayment.id,
            'lecture_id': null
          }
        

      }else if (this.itemForPayment.type == 'Subject') {
        arrlist.forEach( (element, i) => {
          
          if ( element.course_id == this.itemForPayment.course_id && (element.subject_id == this.itemForPayment.id || element.subject_id == null) && element.chapter_id == null ){
            isExist = true
          }
          if (this.itemForPayment.id == element.subject_id && element.course_id == this.itemForPayment.course_id && (element.chapter_id != null || element.lecture_id != null)) {
          
            newArrayToRemove.push(element)
            newArrayDetailToRemove.push(this.$store.state.payments.itemDetailList[i])
            
          }
        })
        item = {
          'course_id': this.itemForPayment.course_id,
          'subject_id': this.itemForPayment.id,
          'chapter_id': null,
          'lecture_id': null
        }


      } else  {
        this.$store.state.payments.itemList.forEach( (element, i) => {
          if (this.itemForPayment.id == element.course_id) {
            
            newArrayToRemove.push(element)
            newArrayDetailToRemove.push(this.$store.state.payments.itemDetailList[i])
          }
        })
        item = {
          'course_id': this.itemForPayment.id,
          'subject_id': null,
          'chapter_id': null,
          'lecture_id': null
        }
      }
      if(newArrayToRemove.length) {

        this.removeItemArray(newArrayToRemove, newArrayDetailToRemove).then((response)=>{
          if(response){
            this.payment.code = null
            if (!isExist) {
              this.$store.state.payments.itemList.push(item)
              this.$store.state.payments.itemDetailList.push(this.itemForPayment)
            }
          }
        })
      } else {
        this.payment.code = null
        if (!isExist) {
          this.$store.state.payments.itemList.push(item)
          this.$store.state.payments.itemDetailList.push(this.itemForPayment)
        }
      }
    },
    removeItemArray (newArrayToRemove, newArrayDetailToRemove) {
      return new Promise ((resolve, reject) => {
        let count = 0
          newArrayToRemove.forEach( (el, i) => {
            this.itemList.splice(this.itemList.indexOf(el), 1 )
            this.itemDetailList.splice( this.itemDetailList.indexOf(newArrayDetailToRemove[i]), 1 )
            count++
            if(newArrayToRemove.length == count)
            {
              resolve(true)
            }
        })
      })
    },

    removeItem (index) {
      this.$store.state.payments.itemList.splice( index, 1 )
      this.$store.state.payments.itemDetailList.splice( index, 1 )
    },
    
    onSubmitPayment (data) {
      let obj = {
        'user_id' : this.payment.user_id,
        'amount' : parseInt(data.amount),
        'discount' : data.discount ? parseInt(data.discount) : 0,
        'payment_method' : data.payment_method,
        'items' : this.$store.state.payments.itemList
      }
      this.purchaseList(obj).then((response) => {
        console.log(response)
        if (response.status == 'OK') {
          this.color= 'success'
          this.noticeMessage = 'Success ! ' + response.messages
          this.dialog = false
          this.$store.state.payments.itemList = []
          this.$store.state.payments.itemDetailList = []
          this.snack('top')
        } else {
          this.color= 'warning'
          this.noticeMessage = 'Warning ! ' + response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    closeModal () {
      this.dialog = false
    },
    
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }
      this.snackbar = true
    }
  }
}
</script>
